import { render, staticRenderFns } from "./orderItemDiscountPopover.vue?vue&type=template&id=bdc2e136&"
import script from "./orderItemDiscountPopover.vue?vue&type=script&lang=js&"
export * from "./orderItemDiscountPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports